import { storeWrapper } from '../storeWrapper'

const initialState = {
  open: false
}

export const useDashboardVideoStore = storeWrapper('useDashboardVideoStore', (set) => ({
  ...initialState,
  toggleVideoModal: (bool) => set({ open: bool }),
  reset: () => set(initialState)
}))
